import {
  all, put, select, spawn, takeEvery
} from "redux-saga/effects";

import { cloneProject } from "API/Clone";
import { selectSelectedProjectsCount } from "Store/Selectors/UI";
import { IProject } from "Model/Storage/IProject";
import { getProjectsById } from "Workers/Projects";
import {
  projectsCloneNext,
  projectsCloneStart,
  projectsCloneError,
  projectsCloneSuccess,
  projectsAdd,
  projectsCloneDialog
} from "../Actions";
import { selectCloneIndex, selectCloningProjectId } from "../Selectors/Clone";
import { callWithAuth } from "./CallWithAuth";
import { sortAndFilterSaga } from "./Projects";

function* cloneItemSaga() {
  try {
    const [cloningProjectId, cloneIndex, selectedProjectsCount] = yield all([
      select(selectCloningProjectId),
      select(selectCloneIndex),
      select(selectSelectedProjectsCount)
    ]);

    const hasMore = cloneIndex + 1 < selectedProjectsCount;
    yield put(projectsCloneDialog(hasMore));

    const clonedProjectId = yield callWithAuth(cloneProject, cloningProjectId);
    const clonedProjects: IProject[] = yield callWithAuth(getProjectsById, [clonedProjectId[`@id`]]);
    yield put(projectsAdd(clonedProjects));
    yield all([hasMore ? put(projectsCloneNext()) : put(projectsCloneSuccess()), spawn(sortAndFilterSaga)]);
  } catch (e) {
    console.error(e);
    yield put(projectsCloneError());
  }
}

export function* CloneSaga() {
  yield takeEvery([projectsCloneStart, projectsCloneNext], cloneItemSaga);
}
